/* unplugin-vue-components disabled */import script from "./CommonInfoDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommonInfoDialog.vue?vue&type=script&setup=true&lang=ts"

import "./CommonInfoDialog.vue?vue&type=style&index=0&id=8fd348e0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8fd348e0"]])

export default __exports__